import { render, staticRenderFns } from "./DataTableBoletos.vue?vue&type=template&id=4e10e1e7&scoped=true&"
import script from "./DataTableBoletos.vue?vue&type=script&lang=js&"
export * from "./DataTableBoletos.vue?vue&type=script&lang=js&"
import style0 from "./DataTableBoletos.vue?vue&type=style&index=0&id=4e10e1e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e10e1e7",
  null
  
)

export default component.exports